/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { typography, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TaskNumber = styled.span({
  fontWeight: 'bold',
});

// override AK Checkbox styles to force checkbox
// labels to wrap within their container correctly
// pending tasks are disabled so the label is very light (color.text.disabled)
// we're overriding to make the text more readable for pending tasks
export const TaskCheckboxWrapper = styled.div<{
  rightAlignIcons?: boolean;
  pending?: boolean;
}>(props => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: props.rightAlignIcons ? 'space-between' : '',
  '& label': {
    color: props.pending ? token('color.text.subtlest', colors.N200) : 'auto',
    '& > span': {
      overflowWrap: 'break-word',
      wordWrap: 'break-word',
      wordBreak: 'break-all',
    },
  },
}));

export const TaskIcons = styled.span({
  display: 'flex',
});

export const PendingLozengeContainer = styled.div({
  position: 'relative',
  paddingLeft: token('space.100', '8px'),
});

export const TaskCardFooter = styled.div<{ kind: 'edit' | 'save' }>(
  ({ kind }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: kind === 'edit' ? 'center' : 'space-between',
    width: '100%',
    boxSizing: 'border-box',
    marginTop: token('space.100', '8px'),
    paddingTop: token('space.100', '8px'),
    paddingLeft: token('space.100', '8px'),
    paddingRight: token('space.100', '8px'),
    borderTop: `1px solid ${token('color.border', colors.N30)}`,
  })
);

export const TaskContainer = styled.li({
  marginTop: token('space.100', '8px'),
  '&:not(:last-of-type)': {
    marginBottom: token('space.100', '8px'),
  },
  '&:last-of-type': {
    marginBottom: 0,
  },
});

export const TaskList = styled.ul({
  listStyle: 'none',
  paddingLeft: 0,
});

export const TaskUsername = styled.span({
  display: 'flex',
  flexDirection: 'row',
  fontWeight: 500,
  color: token('color.text.subtle', colors.N500),
});

export const TaskUsernameContainer = styled.div({
  display: 'block',
  paddingLeft: token('space.100', '8px'),
  flexGrow: 1,
  maxWidth: '100%',
});

export const TaskContent = styled.div({
  marginTop: token('space.050', '4px'),
});

export const TaskAvatarContainer = styled.div({
  display: 'flex',
});

export const TaskModificationLinks = styled.ul<{ hasSeparator?: boolean }>(
  ({ hasSeparator }) => ({
    /* padding lines the task edit/delete links up with the task text */
    padding: '0 0 0 28px',
    margin: 0,
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',

    /* "> li" needed for specificity to apply margin 0 */
    '& > li': {
      margin: 0,
      display: 'flex',
      alignItems: 'center',

      ...(hasSeparator && {
        '&:not(:last-of-type)::after': {
          color: 'inherit',
          content: "'·'",
          display: 'inline-block',
          textAlign: 'center',
          verticalAlign: 'middle',
          width: token('space.200', '16px'),
        },
      }),
    },
  })
);

export const EditCommentTaskErrorMessage = styled.div({
  ...typography.h200(),
  fontWeight: 'normal',
  color: token('color.text.danger', colors.R400),
  marginTop: token('space.050', '4px'),
  marginLeft: token('space.500', '40px'),
});
